import C from '../actions/constants'

export const processYield = (state = {}, action) => {
    switch (action.type) {
        case C.SET_PROCESS_YIELD_VALUES:
            return { ...state, ...action.payload }
        default:
            return state
    }
}